import {connect} from "react-redux"
import {IncomingHttpHeaders} from "http"
import {getLocaleFromHeaders, REALM_HEADER, TERRITORY_HEADER, getCurrencySymbol} from "@next/utils"
import State from "../../ducks/state"
import {mapDispatchToProps} from "../CountryLangSelector/connect"
import {REGION_UK, COUNTRY_GB} from "../../config/constants"
import {formatCdnPath} from "../../utils/getCdnUrl"

const getIconUrl = (area: string) => formatCdnPath(`/icons/shared/countryflags/${area.toLowerCase()}.png`)

export const mapStateToProps = (state: State) => {
    const {
        request: {headers, currencyCode},
        countrySelector: {isEnableCountrySelectorButton},
        text: {
            burgerMenu: {
                changeCountry: {title, description},
            },
        },
    } = state
    const realm = (headers as IncomingHttpHeaders)[REALM_HEADER] as string
    const territory = (headers as IncomingHttpHeaders)[TERRITORY_HEADER] as string

    const alteredTerritory = territory.toLowerCase() === COUNTRY_GB ? REGION_UK : territory

    const locale = getLocaleFromHeaders(headers || {})
    const currencyConfig = getCurrencySymbol(locale, realm, currencyCode) as string

    const sub =
        description && currencyConfig && alteredTerritory
            ? `${alteredTerritory.toUpperCase()}${description}${currencyConfig}`
            : null
    return {
        iconUrl: getIconUrl(territory),
        isEnableCountrySelectorButton,
        territory: alteredTerritory.toUpperCase(),
        title,
        sub,
        alteredTerritory,
        currencyConfig,
        templating: state.template,
    }
}

export default connect(mapStateToProps, mapDispatchToProps)
